import { WarningIcon } from '@chakra-ui/icons';
import { Box, Button, Code, Container, Heading, Text, VStack } from '@chakra-ui/react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { urlNavigate } from '../helper/utils/navigation';

const ErrorPage = () => {
    const error = useRouteError();
    const navigate = useNavigate();

    console.error(error);

    return (
        <Container maxW='container.md' py={20} bg='white'>
            <VStack spacing={6} align='center'>
                <Box bg='white' textAlign='center' py={10} px={6} borderRadius='2xl' shadow='md' w='full'>
                    <WarningIcon boxSize={'50px'} color={'orange.300'} />
                    <Heading as='h2' size='xl' mt={6} mb={2}>
                        Whoops! Something went wrong.
                    </Heading>
                    <Text color={'gray.500'} mb={6}>
                        We're sorry for the inconvenience. An error occurred while processing the data.
                    </Text>

                    {error && (
                        <Box mt={4} p={4} textAlign='left' bg='blackAlpha.50' borderRadius='md' w='full' overflowX='auto'>
                            <Text fontWeight='bold' mb={2}>
                                Error Details:
                            </Text>
                            <Code p={2} borderRadius='sm' w='full'>
                                {error.statusText || error.message || 'Unknown error'}
                            </Code>
                        </Box>
                    )}

                    <VStack mt={10} spacing={4} w='full'>
                        <Button colorScheme='blue' bgGradient='linear(to-r, blue.400, blue.500, blue.600)' color='white' variant='solid' onClick={() => navigate(urlNavigate('online-sales', 'home'))} w='full'>
                            Back to Home
                        </Button>
                        <Button variant='ghost' onClick={() => window.location.reload()} w='full'>
                            Reload Page
                        </Button>
                    </VStack>
                </Box>
            </VStack>
        </Container>
    );
};

export default ErrorPage;
